<template>
  <div class="date-picker-container" :class="inline ? 'mx-auto' : ''">
    <input
      type="date" :value="val" :min="min" :max="max" :disabled="disabled"
      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent disabled:bg-gray-200 disabled:cursor-not-allowed"
      @input="onDateChange"
    >
    <div class="flex items-end justify-between mt-2">
      <button
        type="button" :disabled="disabled"
        class="text-sm underline cursor-pointer text-primary-400 hover:text-primary-600 disabled:text-gray-400 disabled:cursor-not-allowed"
        @click="forever"
      >
        Forever
      </button>
    </div>
  </div>
</template>

<script>
import { API } from "@/api";
import dayjs from "dayjs";

export default {
  props: {
    dt: String,
    min: String,
    max: String,
    inline: Boolean,
    disabled: Boolean,
  },
  emits: { "on:update": null },
  data() {
    return {
      val: this.dt,
    };
  },
  watch: {
    dt: {
      immediate: true,
      handler(newVal) {
        this.val = newVal;
      },
    },
  },
  methods: {
    onDateChange(event) {
      if (this.disabled) return;
      this.val = event.target.value;
      this.$emit("on:update", this.val);
    },

    forever() {
      if (this.disabled) return;
      const foreverDate = "9999-12-31";

      if (this.isDateValid(foreverDate)) {
        this.val = foreverDate;
        this.$emit("on:update", this.val);
      }
    },
    isDateValid(date) {
      let valid = true;

      if (this.min && dayjs(date).isBefore(this.min)) {
        valid = false;
      }
      if (this.max && dayjs(date).isAfter(this.max)) {
        valid = false;
      }

      return valid;
    },
  },
};
</script>
